export default "<p>nurse-point-sale-register-patient-update works!</p>\n"